import connectionBO from "../../services/connectionBO";
import Globals from "../../components/globals";
import httpService from "../../components/service";

export const countdown = {
    namespaced: true,
    state: {
        countdown: {},
        countDownsActived: {},
        countDownsNext: {}
    },
    mutations: {
        LIST_COUNTDOWN: (state, countdown) => {
            state.countdown = countdown;
        },
        FILTER_COUNTDOWN: (state, countDownActived) => {
            state.countDownsActived = countDownActived;
        },
        FILTER_COUNTDOWNNEXT: (state, countDownsNext) => {
            state.countDownsNext = countDownsNext;
        }
    },
    getters: {
        getCountDown(state) {
            return state.countdown;
        },
        getCountDownActived(state) {
            return state.countDownsActived;
        },
        getCountDownNext(state) {
            return state.countDownsNext;
        }
    },
    actions: {
        listCountDown(context, value) {
            return connectionBO.getListCountDown(value).then(response => {
                if (response.code === 400 || response.code === 404) {
                    console.error("Error response API :", response.message);
                } else {
                    let countDownsActived = response.filter(
                        v =>
                            Globals.convertGmtToLocal(new Date(v.startDate)).getTime() <= Globals.convertGmtToLocal(new Date()).getTime() &&
                            Globals.convertGmtToLocal(new Date(v.endDate)).getTime() >= Globals.convertGmtToLocal(new Date()).getTime()
                    );
                    let countDownsNext = response.filter(
                        v => Globals.convertGmtToLocal(new Date(v.startDate)).getTime() > Globals.convertGmtToLocal(new Date()).getTime()
                    );
                    context.commit("LIST_COUNTDOWN", response);
                    context.commit("FILTER_COUNTDOWN", countDownsActived);
                    context.commit("FILTER_COUNTDOWNNEXT", countDownsNext);
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/countdown/CountDownStore.js